import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusCircleIcon, UserPlusIcon } from 'lucide-react';
import { useAuth } from './AuthContext';
interface TeamMember {
  email: string;
  role: string;
}
export function InviteTeammates() {
  const navigate = useNavigate();
  const {
    user,
    completeRegistration,
    isAuthenticated
  } = useAuth();
  const [teamMembers, setTeamMembers] = useState<TeamMember[]>([{
    email: '',
    role: 'Member'
  }]);
  const [isLoading, setIsLoading] = useState(false);
  const handleEmailChange = (index: number, email: string) => {
    const updatedMembers = [...teamMembers];
    updatedMembers[index].email = email;
    setTeamMembers(updatedMembers);
  };
  const handleRoleChange = (index: number, role: string) => {
    const updatedMembers = [...teamMembers];
    updatedMembers[index].role = role;
    setTeamMembers(updatedMembers);
  };
  const addTeamMember = () => {
    setTeamMembers([...teamMembers, {
      email: '',
      role: 'Member'
    }]);
  };
  const handleContinue = async () => {
    setIsLoading(true);
    const validInvites = teamMembers.filter(member => member.email.trim() !== '');
    try {
      if (user) {
        await completeRegistration({
          ...user,
          hasInvitedTeam: true
        });
      }
      setTimeout(() => {
        setIsLoading(false);
        window.location.href = '/';
      }, 1000);
    } catch (error) {
      console.error('Error completing registration:', error);
      setIsLoading(false);
    }
  };
  const handleSkip = async () => {
    try {
      if (user) {
        await completeRegistration({
          ...user,
          hasInvitedTeam: false
        });
      }
      window.location.href = '/';
    } catch (error) {
      console.error('Error completing registration:', error);
    }
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4" data-id="element-46">
      <div className="max-w-2xl w-full" data-id="element-47">
        <div className="text-center mb-12" data-id="element-48">
          <img src="https://cdn.magicpatterns.com/uploads/ssm8opUN7FjpcwsqK5Tnq3/accrue_logo.png" alt="Accrue" className="h-32 mx-auto mb-12" data-id="element-49" />
          <h1 className="text-4xl font-bold mb-2" data-id="element-50">Invite</h1>
          <p className="text-gray-600" data-id="element-51">
            Add team members to collaborate on your MGA portal
          </p>
        </div>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 mb-6" data-id="element-52">
          <div className="mb-8" data-id="element-53">
            <div className="flex items-center mb-6" data-id="element-54">
              <UserPlusIcon className="mr-3 text-blue-600" size={24} data-id="element-55" />
              <h2 className="text-2xl font-semibold" data-id="element-56">Invite your teammates</h2>
            </div>
            <p className="text-gray-600 mb-6" data-id="element-57">
              Work in the MGA portal is more effective with your team. Invite
              them now to collaborate on your feasibility study.
            </p>
            <div className="space-y-4" data-id="element-58">
              <div className="grid grid-cols-4 gap-4 font-medium text-sm text-gray-700 mb-1" data-id="element-59">
                <div className="col-span-3" data-id="element-60">Email</div>
                <div className="col-span-1" data-id="element-61">Role</div>
              </div>
              {teamMembers.map((member, index) => <div key={index} className="grid grid-cols-4 gap-4" data-id="element-62">
                  <div className="col-span-3" data-id="element-63">
                    <input type="email" value={member.email} onChange={e => handleEmailChange(index, e.target.value)} placeholder="colleague@company.com" className="w-full p-3 border border-gray-300 rounded-md" data-id="element-64" />
                  </div>
                  <div className="col-span-1" data-id="element-65">
                    <select value={member.role} onChange={e => handleRoleChange(index, e.target.value)} className="w-full p-3 border border-gray-300 rounded-md" data-id="element-66">
                      <option value="Member" data-id="element-67">Member</option>
                      <option value="Admin" data-id="element-68">Admin</option>
                      <option value="Viewer" data-id="element-69">Viewer</option>
                    </select>
                  </div>
                </div>)}
              <button onClick={addTeamMember} className="flex items-center text-blue-600 font-medium text-sm mt-2" data-id="element-70">
                <PlusCircleIcon size={16} className="mr-2" data-id="element-71" />
                Add another
              </button>
            </div>
          </div>
          <div className="flex flex-col space-y-3" data-id="element-72">
            <button onClick={handleContinue} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-md transition duration-150 ease-in-out" disabled={isLoading} data-id="element-73">
              {isLoading ? 'Processing...' : 'Continue'}
            </button>
            <button onClick={handleSkip} className="w-full text-gray-600 font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out" data-id="element-74">
              I'll do it later
            </button>
          </div>
        </div>
      </div>
    </div>;
}